import { Component, input } from '@angular/core';
import type { Uc2StageStatus } from '../../models/uc2-view-state';

export interface LifecycleRailStage {
  label: string;
  status: Uc2StageStatus;
  detail: string;
}

@Component({
  selector: 'app-uc2-lifecycle-rail',
  templateUrl: './uc2-lifecycle-rail.component.html',
  styleUrl: './uc2-lifecycle-rail.component.scss',
})
export class Uc2LifecycleRailComponent {
  stages = input.required<readonly LifecycleRailStage[]>();
  ariaLabel = input('Case lifecycle');
}
